var klaviyo = klaviyo || [];
klaviyo.init({
  account: klaviyoJson.account,
  platform: 'shopify',
});
klaviyo.enable('backinstock', {
  trigger: {
    product_page_text: 'Benachrichtige mich, wenn verfügbar',
    product_page_class: 'button',
    product_page_text_align: 'center',
    product_page_margin: '0px',
    alternate_anchor: 'ProductSubmitButton',
    replace_anchor: true,
  },
  modal: {
    headline: '{product_name}',
    body_content:
      'Registriere dich, um eine Benachrichtigung zu erhalten, wenn dieser Artikel wieder auf Lager ist.',
    email_field_label: 'Email',
    button_label: 'Benachrichtige mich, wenn verfügbar',
    subscription_success_label: 'Du bist dabei! Wir informieren dich, wenn es wieder verfügbar ist.',
    footer_content: '',
    additional_styles: `@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue'); 
    .btn-success{
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 400;
        background-color: #748b46;
        border: 1px solid #748b46;
        line-height: 1em;
        display: flex;
        width: 100%;
        font-weight: 700;
        justify-content: center;
        max-height: 58px;
        } 
      .btn-success:hover{
          color: #748b46;
          border: 1px solid #748b46;
          background: #fff;
          box-sizing: border-box;
        }
      @media (max-width: 1023px){
          .btn-success{
            font-size: 14px;
            font-weight: 400;
          } 
      }
    `,
    drop_background_color: '#000',
    background_color: '#fff',
    text_color: '#222',
    button_text_color: '#fff',
    button_background_color: '#748b46',
    close_button_color: '#ccc',
    error_background_color: '#fcd6d7',
    error_text_color: '#C72E2F',
    success_background_color: '#d3efcd',
    success_text_color: '#1B9500',
  },
});